import Input from "../../Input"

const SgInfoChannel = ({ index, values, serverData }) => {
    return (
        <div className="mx-14 h-full">
            <h6 className="flex justify-center">چنل مشخصات رنک {index + 1}</h6>
            <div className="grid grid-cols-2 gap-5">
                <div className="font-sans">
                    <Input
                        type="number"
                        label="ایدی چنل *"
                        name={`sgInfoChannels-${index}-id`}
                        options={serverData?.channelList}
                        placeholder="ChannelID"
                        autoComplete="off"
                        defaultValue={values?.id}
                        dir="ltr"
                    />
                </div>

                <div className="">
                    <Input
                        type="text"
                        label="ایدی رنک *"
                        name={`sgInfoChannels-${index}-sgId`}
                        options={serverData?.sgList}
                        class="border   text-sm rounded-lg  block w-full p-2.5 bg-gray-700 border-gray-600 placeholder-gray-400 text-white "
                        placeholder="ServerGroup ID"
                        defaultValue={values?.sgId}
                        autoComplete="off"
                        dir="ltr"
                    />
                </div>
            </div>
            <div className="grid grid-cols-2 gap-5">
                <div className="mt-2">
                    <Input
                        type="text"
                        label="فرمت اسم چنل *"
                        name={`sgInfoChannels-${index}-nameFormat`}
                        placeholder="Format"
                        autoComplete="off"
                        defaultValue={values?.nameFormat}
                        dir="ltr"
                    />
                </div>
                <div className="mt-2">
                    <label class="block">فرمت دسکریپشن چنل</label>
                    <textarea
                        type="text"
                        name={`sgInfoChannels-${index}-descriptionFormat`}
                        class="styled-input"
                        placeholder="Description Format"
                        autoComplete="off"
                        defaultValue={values?.descriptionFormat}
                        dir="ltr"
                    />
                </div>
            </div>

            <div className="mt-5 p-2 text-gray-400 border-gray-700 border rounded-md font-sans">
                <span>متغیرهای اسم چنل:</span>
                <div dir="ltr">
                    <div>%c: تعداد کل</div>
                    <div>%o: تعداد انلاین</div>
                </div>
                <hr className="bg-gray-500 border-none h-[2px] w-full" />
                <span>متغیرهای دسکریپشن چنل:</span>
                <div className="grid grid-cols-3" dir="ltr">
                    <div>%name: اسم</div>
                    <div>%i: شاخص</div>
                    <div>%ON: وضعیت انلاین به انگلیسی</div>
                    <div>%on: وضعیت انلاین به فارسی</div>
                </div>
            </div>
        </div>
    )
}

export default SgInfoChannel
